import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { TaskId } from 'api/models';
import { RoutePaths } from 'constant';
import { useNavigateToTask } from 'hooks/use-navigate-to-task';

export const TaskDetailsPageResponsive = () => {
  const { taskId, projectId } =
    useParams<{ taskId: string; projectId: string }>();
  const navigateToTask = useNavigateToTask();

  useEffect(() => {
    navigateToTask(
      TaskId(Number(projectId), Number(taskId)),
      undefined,
      RoutePaths.home,
    );
  }, [navigateToTask, projectId, taskId]);

  return <div />;
};
